import { useApplicationProductsQuery } from './useApplicationProductsQuery';
import { useApplicationProductsSearch } from './useApplicationProductsSearch';
import { ApplicationProduct } from '../types';

export const useApplicationProducts = (applicationId?: string) => {

    const filters: Record<string, string> = {};
    if (applicationId) {
        filters.applicationId = applicationId;
    }

    const { data: items = [], isLoading: loading } = useApplicationProductsQuery(filters);
    const { keyword } = useApplicationProductsSearch();

    // Filter items based on keyword (client-side filtering)
    const visibleItems = items.filter((item: ApplicationProduct) =>
        !keyword ||
        item.productId?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.product?.name?.toLowerCase().includes(keyword.toLowerCase())
    );

    const visibleCount = visibleItems.length;

    return {
        items,
        visibleItems,
        visibleCount,
        loading,
    };
};
